export type ShareResult = 'shared' | 'copied' | 'failed';

/**
 * Compartilha o link do adicional: menu nativo do aparelho quando existe
 * (`navigator.share`), senão copia para a área de transferência. Cancelar o
 * menu nativo não é falha — o titular só desistiu.
 *
 * No share nativo o link vai em `url` (o app de destino o anexa ao texto); na
 * cópia ele vai junto da mensagem, para o titular só colar no WhatsApp.
 */
export async function shareInviteLink(url: string, text: string): Promise<ShareResult> {
  if (typeof navigator !== 'undefined' && typeof navigator.share === 'function') {
    try {
      await navigator.share({ text, url });
      return 'shared';
    } catch (error) {
      if (error instanceof DOMException && error.name === 'AbortError') return 'shared';
      // Sem permissão/suporte real: cai para a cópia.
    }
  }

  try {
    await navigator.clipboard.writeText(text ? `${text} ${url}` : url);
    return 'copied';
  } catch {
    return 'failed';
  }
}
